import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function VendorDeclineModal({ isOpen, onClose, onConfirm, appointmentId, loader }) {
    const { control, formState: { errors }, handleSubmit, reset } = useForm();

    useEffect(() => {
        if (isOpen) reset({ decline_reason: '' });
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
            <form onSubmit={handleSubmit((data) => onConfirm(data))}>
                <ModalHeader className="header_modal align-items-center">
                    <h5 className="modal-title_u">Decline Appointment</h5>
                </ModalHeader>
                <ModalBody className="modal_form_body">
                    <div className="step_cards step_1">
                        <h2>Appointment ID: {appointmentId}</h2>
                        <div className="row-primary">
                            <h2>Reason *</h2>
                            <div className="w-100">
                                <Controller
                                    name="decline_reason"
                                    control={control}
                                    rules={{ required: 'Please provide a reason for declining' }}
                                    render={({ field }) => (
                                        <>
                                            <textarea
                                                className="type_inp input-in"
                                                placeholder="Write reason..."
                                                {...field}
                                            />
                                            {errors?.decline_reason?.message && (
                                                <ErrorMessage text={errors.decline_reason.message} />
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <SubmitButton buttonType="submit" loader={loader} className="tomatoRed" btnText="Decline" />
                    <button className="table_delete" type="button" onClick={onClose}>Cancel</button>
                </ModalFooter>
            </form>
        </Modal>
    );
}

export default VendorDeclineModal;
